import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MonitoringService } from '../../../core/services/monitoring/legal-entity-client/monitoring.service'
import { MatCardModule } from '@angular/material/card'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { AddressClientCreateComponent } from '../../address/address-client-create/address-client-create.component'
import { ContactClientCreateComponent } from '../../contact/contact-client-create/contact-client-create.component'
import { TaxDocumentClientCreateComponent } from '../../tax-document/tax-document-client-create/tax-document-client-create.component'
import { PaymentMethodsClientCreateComponent } from '../../payment/payment-client-create/payment-methods-client-create.component'
import { BankDetailsClientCreateComponent } from '../../bank/bank-details-client-create/bank-details-client-create.component'
import { ConsultantClientCreateComponent } from '../../person/consultant-client-create/consultant-client-create.component'
import { MatDividerModule } from '@angular/material/divider'
import { IndividualClientService } from '../../../core/services/monitoring/individual-client/individual-client.service'
import { NgxMaskDirective } from 'ngx-mask'
import { AssociateSubClientCreateComponent } from './associate-sub-client-create/associate-sub-client-create.component'
import { ExamRelationPatientCreateComponent } from '../../exam/exam-relation-patient-create/exam-relation-patient-create.component'
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from '@angular/material/slide-toggle'
import { DecimalInputDirective } from '../../../shared/directives/decimalInput'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { convertCurrency } from '../../../shared/utils/utils'
import { CommissionDividerService } from '../../../core/services/price-quote/commission-divider/commission-divider.service'
import { ResponsibleClientCreateComponent } from '../../person/responsible-client-create/responsible-client-create.component'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerModule,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import { HabitsService } from '../../../core/services/employee/employee-role/habits.service'
import {MatOption} from '@angular/material/core';
import {MatSelect} from '@angular/material/select';
import {HealthUnitService} from '../../../core/services/health-unit/location/health-unit.service';
import {AlertPatientCreateComponent} from '../../alert/alert-patient-create/alert-patient-create.component';
import {MatCheckbox} from '@angular/material/checkbox';
import {MunicipalityService} from '../../../core/services/municipality/municipality/municipality.service';
import {
  MedicalInsurancePatientCreateComponent
} from '../../medical-insurance/medical-insurance-patient/alert-patient-create/medical-insurance-patient-create.component';
import { PreviousDiseasesService } from '../../../core/services/previousDiseases/diseases/previous-diseases.service'

@Component({
  selector: 'patient-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatInput,
    MatDividerModule,
    AddressClientCreateComponent,
    ContactClientCreateComponent,
    NgxMaskDirective,
    ExamRelationPatientCreateComponent,
    DecimalInputDirective,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatOption,
    MatSelect,
    AlertPatientCreateComponent,
    MatCheckbox,
    MedicalInsurancePatientCreateComponent,
  ],
  templateUrl: './patient-create.component.html',
  styleUrl: './patient-create.component.scss',
  providers: [
    MonitoringService,
    IndividualClientService,
    CommissionDividerService,
  ],
  standalone: true,
})
export class PatientCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private legalEntityClientService: MonitoringService,
    private commissionDividerService: CommissionDividerService,
    private individualClientService: IndividualClientService,
    private unidadeSaudeService: HealthUnitService,
    private municipalityService: MunicipalityService,
    private habitoService: HabitsService,
    private previousDiseasesService: PreviousDiseasesService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<PatientCreateComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  @Output() responseCreate = new EventEmitter()
  @ViewChild('birth') datepicker: MatDatepicker<any> | undefined
  healthForm: FormGroup = new FormGroup({})
  formLegalEntity: FormGroup = new FormGroup({})
  formIndividual: FormGroup = new FormGroup({})
  formFinancial: FormGroup = new FormGroup({})
  listTypeClient: any = [
    { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]
  listaUnidades: any = []
  listaMunicipios: any = []
  listaHabitos: any = []
  listaConvenios: any = []
  listaDoencas: any[] = []
  typeClient: 'legal' | 'individual' = 'legal'

  loading: boolean = false

  addressList: any[] = []
  contactList: any[] = []
  taxDocumentList: any[] = []
  paymentMethodsList: any[] = []
  bankDetailsList: any[] = []
  consultantList: any[] = []
  tariffList: any[] = []
  subClientList: any[] = []
  responsibleList: any[] = []
  alertList: any[] = []
  isSelectHealthUnitActive: boolean = false
  commissionDivider: any = {
    taxa: 0.0,
    divisor: 0.0,
    comissao: 0.0,
  }

  ngOnInit(): void {
    this.createForm()
    this.getHabitos()
    this.getDoencas()
    this.getMunicipio()
  }
  getMunicipio() {
    this.municipalityService.listActiveMunicipality().subscribe({
      next: (response: any) => {
        if (response.data) {
          this.listaMunicipios = response.data
        }
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }
  onMunicipioChange() {
    const municipioId = this.formLegalEntity.get('municipality')?.value

    this.formLegalEntity.get('healthUnit')?.reset()

    if (municipioId !== 0) {
      this.isSelectHealthUnitActive = true
      this.formLegalEntity.get('healthUnit')?.enable()
      this.getUnidadesSaude(municipioId)
    } else {
      this.isSelectHealthUnitActive = false
      this.formLegalEntity.get('healthUnit')?.disable()
    }
  }
  openDatepicker() {
    if (this.datepicker) {
      this.datepicker.open()
    }
  }
  getUnidadesSaude(idMunicip: number | null = null) {
    this.loading = true
    console.log(idMunicip)
    if (idMunicip == null) {
      this.unidadeSaudeService.listActiveLocation().subscribe({
        next: (response: ResponseRequestModel) => {
          this.listaUnidades = response.data
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
        },
      })
    } else {
      this.unidadeSaudeService
        .listActiveLocationByMunicip(idMunicip)
        .subscribe({
          next: (response: ResponseRequestModel) => {
            this.listaUnidades = response.data
          },
          error: (err: ErrorRequestModel) => {
            this.loading = false
            this.snackbar.errorRequest(err)
          },
          complete: () => {
            this.loading = false
          },
        })
    }
  }
  getHabitos() {
    this.loading = true
    this.habitoService.listHabits().subscribe({
      next: (response: ResponseRequestModel) => {
        //this.snackbar.success("Unidades de saúde listadas com sucesso!")
        this.listaHabitos = response.data
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
  getDoencas() {
    this.loading = true
    this.previousDiseasesService.listDiseases().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listaDoencas = response.data
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }
  close() {
    this.responseCreate.emit()
    this.dialogRef.close()
  }

  createForm(): void {
    this.formLegalEntity = this.formBuilder.group({
      municipality: [null],
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      birth: ['', [Validators.required]],
      cpf: ['', [Validators.required]],
      healthUnit: [{ value: null, disabled: true }, [Validators.required]],
      rg: ['', [Validators.required]],
      password: ['', [Validators.required]],
      maritalStatus: [null, [Validators.required]],
      sex: [0, [Validators.required]],
      consentForm: [false, [Validators.required]],
    })

    this.healthForm = this.formBuilder.group({
      height: ['', [Validators.required]],
      weight: ['', [Validators.required]],
      habits: [[]],
      previousDiseases: [[]],
      history: ['', [Validators.required]],
    })
    this.formIndividual = this.formBuilder.group({
      name: ['', [Validators.required]],
      email: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      birth: ['', [Validators.required]],
      cpf: ['', [Validators.required]],
      // cpf: [
      //   '',
      //   [Validators.required, Validators.pattern(/\d{3}\.\d{3}\.\d{3}-\d{2}/)],
      // ],
    })
    this.formFinancial = this.formBuilder.group({
      // commission: ['', [Validators.required]],
      // divider: ['', [Validators.required]],
      doff: [true],
      tax: [convertCurrency(0)],
      commission: [convertCurrency(0)],
      divider: [convertCurrency(0)],
    })
  }

  getList(
    list: any[],
    typeList:
      | 'alert'
      | 'address'
      | 'contact'
      | 'tax_document'
      | 'paymentMethod'
      | 'bankDetails'
      | 'consultant'
      | 'taxDocument'
      | 'tariff'
      | 'responsible'
      | 'medical_insurance'
      | 'subClient',
  ): void {
    console.log('typelist ', typeList, ' lista ', list)
    switch (typeList) {
      case 'alert':
        this.alertList = list
        break
      case 'address':
        this.addressList = list
        break
      case 'contact':
        this.contactList = list
        break
      case 'bankDetails':
        this.bankDetailsList = list
        break
      case 'consultant':
        this.consultantList = list
        break
      case 'taxDocument':
        this.taxDocumentList = list
        break
      case 'paymentMethod':
        this.paymentMethodsList = list
        break
      case 'tariff':
        this.tariffList = list
        break
      case 'subClient':
        this.subClientList = list
        break
      case 'responsible':
        this.responsibleList = list
        break
      case 'medical_insurance':
        this.listaConvenios = list
        break
    }
  }

  checkInvalidForm() {
    return (
      this.formLegalEntity.invalid ||
      this.healthForm.invalid ||
      this.loading ||
      this.addressList.length == 0
    )
  }

  createLegalModel() {
    const birthValue = this.formLegalEntity.get('birth')?.value
    let data_nascimento = ''
    if (birthValue) {
      if (typeof birthValue === 'string') {
        data_nascimento = birthValue.split('T')[0]
      } else if (birthValue instanceof Date) {
        data_nascimento = birthValue.toISOString().split('T')[0]
      }
    }

    // Data de consentimento (usar data atual se consentimento foi aceito)
    const consentimento =
      this.formLegalEntity.get('consentForm')?.value ?? false
    const data_consentimento = consentimento
      ? new Date().toISOString().split('T')[0]
      : ''

    return {
      nomeCompleto: this.formLegalEntity.get('name')?.value ?? '',
      telefone: '55' + this.formLegalEntity.get('phone')?.value, // Mudou de telefone_1
      telefone_whatsapp: '55' + this.formLegalEntity.get('phone')?.value,
      email: this.formLegalEntity.get('email')?.value ?? '',
      cpf: this.formLegalEntity.get('cpf')?.value ?? '',
      data_nascimento,
      unidade_id: this.formLegalEntity.get('healthUnit')?.value ?? 0,
      rg: this.formLegalEntity.get('rg')?.value ?? '',
      genero: this.formLegalEntity.get('sex')?.value ?? '',
      senha: this.formLegalEntity.get('password')?.value ?? '',
      estadoCivil: this.formLegalEntity.get('maritalStatus')?.value ?? '', // Mudou de estado_civil
      consentimento_aceito: consentimento,
      data_consentimento, // Novo campo
      altura:
        Number(
          String(this.healthForm.get('height')?.value).replace(',', '.'),
        ) || 0,
      peso:
        Number(
          String(this.healthForm.get('weight')?.value).replace(',', '.'),
        ) || 0,
      habitos: Array.isArray(this.healthForm?.get('habits')?.value)
        ? this.healthForm?.get('habits')?.value
        : this.healthForm?.get('habits')?.value
          ? [this.healthForm?.get('habits')?.value]
          : [],
      historico_paciente: this.healthForm?.get('history')?.value ?? '',
      observacao: this.healthForm?.get('observation')?.value ?? '', // Novo campo
      doencas: Array.isArray(this.healthForm?.get('previousDiseases')?.value)
        ? this.healthForm?.get('previousDiseases')?.value
        : this.healthForm?.get('previousDiseases')?.value
          ? [this.healthForm?.get('previousDiseases')?.value]
          : [],
      ...(this.addressList ?? {}),
      contatos_emergencia: (this.contactList ?? []).map((contact) => ({
        nome: contact.nome_contato_emergencia ?? contact.nome ?? '', // Mudou campo
        telefone: contact.telefone_contato_emergencia ?? contact.telefone ?? '', // Mudou campo
        parentesco:
          contact.parentesco_contato_emergencia ?? contact.parentesco ?? '', // Mudou campo
        email: contact.email ?? contact.email ?? '', // Mudou campo
        ativo: contact.ativo ?? contact.ativo ?? '', // Mudou campo
      })),

      // Lembretes - estrutura corrigida
      lembretes: (this.alertList ?? []).map((item) => ({
        descricao: item.descricao_lembrete ?? item.descricao ?? '', // Mudou campo
        horarios: item.horarios ?? [], // Array de IDs de horários
        dias_semana: item.dias_semana ?? [],
        id_mensagem_template: item.id_mensagem_template ?? null,
      })),

      // Exames - estrutura completamente reformulada
      exames: (this.tariffList ?? []).map((item) => this.formatExame(item)),
      convenios: [...this.listaConvenios],
    }
  }

  // Método auxiliar para formatar exames corretamente
  private formatExame(item: any) {
    const exame: any = {
      tipo_exame_id: item.tipo_exame_id,
      descricaoExame: item.descricaoExame ?? '',
      equipamento_id: item.equipamento_id,
      tutorlocal_associado_id: item.tutorlocal_associado_id,
      subtipo_exame: item.subtipo_exame,
    }

    // Se usar parâmetros personalizados
    if (item.usar_parametros_personalizados && item.parametros) {
      exame.usar_parametros_personalizados = true

      // Se parametros já é array, usa direto
      if (Array.isArray(item.parametros)) {
        exame.parametros = item.parametros
      } else {
        // Senão, cria array com um único parâmetro
        exame.parametros = [
          {
            contexto_id: item.contexto_id ?? 1,
            parametro_minimo: item.parametro_minimo,
            parametro_maximo: item.parametro_maximo,
            tipo_unidade: item.tipo_unidade,
          },
        ]
      }
    } else if (item.parametro_minimo && item.parametro_maximo) {
      // Se tem parâmetros mas não está marcado como personalizado
      exame.usar_parametros_personalizados = true
      exame.parametros = [
        {
          contexto_id: item.contexto_id ?? 1,
          parametro_minimo: item.parametro_minimo,
          parametro_maximo: item.parametro_maximo,
          tipo_unidade: item.tipo_unidade,
        },
      ]
    }

    return exame
  }
  verifyCreate() {
    if (
      this.checkInvalidForm() ||
      this.tariffList.length > 0 ||
      this.contactList.length > 0 ||
      this.alertList.length > 0
    ) {
      this.createMonitoring()
    } else {
      this.createPatient()
    }
  }
  createMonitoring() {
    this.loading = true
    this.legalEntityClientService
      .createMonitoring(this.createLegalModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
          this.close()
        },
        error: (err: any) => {
          this.loading = false
          this.snackbar.error(err.error.message)
        },
        complete: () => {
          this.loading = false
          this.formLegalEntity.reset()
          this.formFinancial.reset()
        },
      })
  }
  createPatient() {
    this.loading = true
    this.legalEntityClientService
      .createPatient(this.createLegalModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseCreate.emit()
          this.close()
        },
        error: (err: any) => {
          this.loading = false
          this.snackbar.error(err.error.message)
        },
        complete: () => {
          this.loading = false
          this.formLegalEntity.reset()
          this.formFinancial.reset()
        },
      })
  }

  onChangeSelect(event: MatSlideToggleChange) {
    if (event.checked) {
      this.fillFormFinancial()
    } else {
      this.fillFormFinancial(true)
    }
  }

  fillFormFinancial(clear: boolean = false) {
    if (!clear) {
      this.formFinancial
        .get('divider')!
        .setValue(convertCurrency(this.commissionDivider.divisor))
      this.formFinancial
        .get('tax')!
        .setValue(convertCurrency(this.commissionDivider.taxa))
      this.formFinancial
        .get('commission')!
        .setValue(convertCurrency(this.commissionDivider.comissao))
      this.formFinancial.get('divider')!.disable()
      this.formFinancial.get('tax')!.disable()
      this.formFinancial.get('commission')!.disable()
    } else {
      this.formFinancial.get('divider')!.setValue(convertCurrency(0))
      this.formFinancial.get('tax')!.setValue(convertCurrency(0))
      this.formFinancial.get('commission')!.setValue(convertCurrency(0))
      this.formFinancial.get('divider')!.enable()
      this.formFinancial.get('tax')!.enable()
      this.formFinancial.get('commission')!.enable()
    }
  }

  getCommissionDivider() {
    this.commissionDividerService.getCommissionDividerDefault().subscribe({
      next: (response: ResponseRequestModel) => {
        this.commissionDivider = {
          taxa: response.data.taxa,
          divisor: response.data.divisor,
          comissao: response.data.comissao,
        }
        this.fillFormFinancial()
      },
      error: (err: ErrorRequestModel) => {
        console.error('err', err)
      },
      complete: () => {},
    })
  }

  createClientIndividual() {
    // this.individualClientService
    //   .createIndividualClient(this.createIndividualModel())
    //   .subscribe({
    //     next: (response: ResponseRequestModel) => {
    //       this.snackbar.success(response.message)
    //       this.responseCreate.emit()
    //       this.close()
    //     },
    //     error: (err: ResponseRequestModel) => {
    //       this.loading = false
    //       this.snackbar.error(err.error)
    //     },
    //     complete: () => {
    //       this.loading = false
    //       this.formIndividual.reset()
    //       this.formFinancial.reset()
    //     },
    //   })
  }
}
